import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import _str from "shared/util/_str";
import PrimaryButton from "shared/components/PrimaryButton";
import LegalText from "apps/payment/components/LegalText";
import { PRODUCT_SUBTYPES } from "shared/payment/constants";

import "./PaymentFormSubmitButton.scss";

const PaymentFormSubmitButton = ({
	productSubtype,
	isProcessing,
	hasSuccessfullyPurchased,
	isPayPalScreen,
}) => {
	let buttonText;

	if (isProcessing) {
		buttonText = _str("Processing");
	} else if (hasSuccessfullyPurchased) {
		buttonText = _str("Success!");
	} else {
		buttonText = _str("Confirm Purchase");
	}

	return (
		<div className="payment-form-submit-button">
			<LegalText
				productSubtype={productSubtype}
				isPayPalScreen={isPayPalScreen}
			/>
			<PrimaryButton
				type="submit"
				disabled={isProcessing || hasSuccessfullyPurchased}
				className={classnames({
					"payment-form-success": hasSuccessfullyPurchased,
				})}
			>
				{buttonText}
			</PrimaryButton>
		</div>
	);
};

PaymentFormSubmitButton.propTypes = {
	productSubtype: PropTypes.oneOf(Object.values(PRODUCT_SUBTYPES))
		.isRequired,
	isProcessing: PropTypes.bool,
	hasSuccessfullyPurchased: PropTypes.bool,
	isPayPalScreen: PropTypes.bool,
};

PaymentFormSubmitButton.defaultProps = {
	isProcessing: false,
	hasSuccessfullyPurchased: false,
	isPayPalScreen: false,
};

export default PaymentFormSubmitButton;



// WEBPACK FOOTER //
// ./src/apps/payment/components/PaymentFormSubmitButton/PaymentFormSubmitButton.jsx